module.exports = __webpack_public_path__ + "assets/img/mecha-btn-a7c866f1.png";